(() => {
  // Keep draft preview and server-rendered view on navigation and native filter URLs.
  const preview = new URL(location.href).searchParams.get('preview_theme_id');
  const current = new URL(location.href);
  if (!current.searchParams.get('view') && [...current.searchParams.keys()].some(key => key.startsWith('filter.') || key === 'page')) {
    current.searchParams.set('view', 'products'); location.replace(current.href); return;
  }
  for (const link of document.querySelectorAll('.lv-search-tabs a, .lv-search-all-link a, .lv-content-all, .lv-search-pagination a, .lv-active-filters a, .lv-filter-actions a')) {
    const url = new URL(link.href);
    if (link.closest('.lv-active-filters, .lv-search-pagination')) url.searchParams.set('view','products');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    link.href = url;
  }
  async function setupQuickFilters(form) {
    if (form.hasAttribute('data-load-scope') && form.querySelector('[data-quick-scope]')) {
      form.setAttribute('aria-busy','true');
      const scopeUrl = new URL(form.action);
      scopeUrl.search = new URLSearchParams(new FormData(form)).toString();
      for (const select of form.querySelectorAll('select')) scopeUrl.searchParams.delete(select.name);
      scopeUrl.searchParams.set('section_id','lv-search-quick-scope');
      if (preview) scopeUrl.searchParams.set('preview_theme_id',preview);
      try {
        const response = await fetch(scopeUrl,{credentials:'same-origin'});
        if (!response.ok) throw new Error('Filter scope unavailable');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const scoped = doc.querySelector('.lv-search-quick-filters');
        if (scoped) form.replaceChildren(...scoped.childNodes);
      } catch (_) { form.querySelectorAll('select').forEach(select => select.disabled=true); }
      finally { form.removeAttribute('aria-busy'); }
    }
    const navigate = event => { event.preventDefault(); event.stopPropagation(); const url = new URL(form.action); const params = new URLSearchParams(new FormData(form)); for (const [key,value] of [...params]) if (!value) params.delete(key); if (preview) params.set('preview_theme_id',preview); url.search = params.toString(); location.assign(url.href); };
    form.addEventListener('submit',navigate);
    form.querySelector('button').addEventListener('click',navigate);
  }
  for (const form of document.querySelectorAll('.lv-search-quick-filters')) setupQuickFilters(form);
  if (customElements.get('lv-search-filters')) return;
  customElements.define('lv-search-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.form = this.querySelector('form');
      this.panel = this.querySelector('[data-filter-panel]');
      this.button = this.querySelector('[data-apply]');
      this.media = matchMedia('(min-width: 1025px)');
      this.resize = () => { this.panel.open = this.media.matches; };
      this.resize(); this.media.addEventListener('change', this.resize);
      this.categories();
      if (preview) { const input=document.createElement('input'); input.type='hidden'; input.name='preview_theme_id'; input.value=preview; this.form.append(input); }
      this.form.addEventListener('change', event => {
        if (event.target.matches('[data-category]')) {
          // A category change starts a new scope; no old attribute filters carry over.
          const url = this.url();
          for (const key of [...url.searchParams.keys()]) if (key.startsWith('filter.') && key !== 'filter.p.product_type') url.searchParams.delete(key);
          url.searchParams.delete('filter.p.product_type');
          if (event.target.value) url.searchParams.set('filter.p.product_type',event.target.value);
          location.assign(url.href); return;
        }
        clearTimeout(this.timer);
        this.button.textContent=this.dataset.show;
        this.timer=setTimeout(() => this.count(), 250);
      });
      this.form.addEventListener('submit', event => { event.preventDefault(); location.assign(this.url().href); });
      this.button.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); location.assign(this.url().href); });
    }
    url() {
      const url=new URL(this.form.action);
      url.search=new URLSearchParams(new FormData(this.form)).toString();
      if (!url.searchParams.get('filter.p.product_type')) url.searchParams.delete('filter.p.product_type');
      return url;
    }
    async categories() {
      const select = this.querySelector('[data-category]');
      if (!select || !select.value) return;
      const selected = select.value;
      const url = new URL(this.form.action);
      url.searchParams.set('q', this.form.elements.q.value);
      url.searchParams.set('type', 'product');
      url.searchParams.set('section_id', 'lv-search-category-options');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      try {
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok || !this.isConnected) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const options = [...doc.querySelectorAll('[data-category-options] option')];
        if (!options.length) return;
        const placeholder = select.options[0].cloneNode(true);
        select.replaceChildren(placeholder, ...options);
        select.value = selected;
      } catch (_) { /* Existing server-rendered options remain usable. */ }
    }
    async count() {
      this.abort?.abort(); this.abort=new AbortController();
      const url=this.url(); url.searchParams.set('section_id',this.dataset.section);
      this.button.setAttribute('aria-busy','true');
      try {
        const response=await fetch(url,{signal:this.abort.signal,credentials:'same-origin'});
        if(!response.ok) throw new Error('Count unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const count=doc.querySelector('[data-lv-result-count]')?.dataset.lvResultCount;
        if(count!==undefined) this.button.textContent=`${this.dataset.show} (${count})`;
      } catch(error) { if(error.name!=='AbortError') this.button.textContent=this.dataset.show; }
      finally { if(!this.abort.signal.aborted) this.button.removeAttribute('aria-busy'); }
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.media?.removeEventListener('change',this.resize); }
  });
})();

